
import React from 'react';
import { Container} from 'react-bootstrap';
import GalleryLight from '../components/galleryLight';


export default class Light extends React.Component{

  constructor(props) {
    super(props);
    this.state = {listOfImages: []};
  }

  importAll(r) {
    return r.keys().map(r);
  }

  componentDidMount() {
    const listOfImages = this.importAll(require.context('../Images/light', false, /\.(png|jpe?g|svg)$/));
    const rows = listOfImages.reduce(function (rows, key, index) { 
      return (index % 3 === 0 ? rows.push([key]) 
        : rows[rows.length-1].push(key)) && rows;
    }, []);
    this.setState({listOfImages:rows});
  }

  render(){
    return (
      <Container>
        <h1 className='text-center m-5'>Flows of Light</h1>
        <h4 className='text-center m-5'>An exploration of movement through light. In collaboration with Daywee Ramarn</h4>
        <GalleryLight listOfImages={this.state.listOfImages} />
      </Container>
    );
  }
}